import Vue from 'vue';

const getQueryString = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
};

const rid = parseInt(getQueryString('rid'), 10);
const i = parseInt(getQueryString('i'), 10);

const vState = Vue.observable({
  i,
  rid,
  lotteryNum: 5,
});

const vMutations = {};

const vApi = {
  list: 'http://www.foshannews.net/zt/2020/wx/kpfs_invention_exhibition/index.json',
  lottery: `./index.php?i=${vState.i}&rid=${vState.rid}&c=entry&method=doLottery&do=commonLottery&m=citygf`,
};

export { vState, vMutations, vApi };
